// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1vs1r","info":"Note_info__3teOG","note":"Note_note__1EZND","actions":"Note_actions__3YXk3"};